import {Text} from '#component/base';
import {NumberInputField, TextInputField} from '#component/partial';
import {NumberInputFieldProps} from '#component/partial/NumberInputField/NumberInputField.types';
import {TextInputFieldProps} from '#component/partial/TextInputField/TextInputField.types';
import {sprinkles} from '#style/sprinkles';

export const CombinedMeasurementInputField = ({
  label = '',
  numberInputProps,
  selectInputProps,
}: {
  label?: React.ReactNode;
  numberInputProps: NumberInputFieldProps;
  selectInputProps: TextInputFieldProps;
}) => {
  const {label: selectLabel, ...otherSelectProps} = selectInputProps;
  const renderedNumberId = numberInputProps.id || numberInputProps.name;
  const renderedSelectId = otherSelectProps.id || otherSelectProps.name;

  return (
    <div className={sprinkles({display: 'flex', dir: 'col', gap: 10, grow: 1})}>
      <Text as="label" htmlFor={renderedNumberId} color="doveGray" variant="label">
        {label}
      </Text>

      <div className={sprinkles({display: 'flex', content: 'stretch', items: 'start'})}>
        <NumberInputField className={sprinkles({grow: 1})} {...numberInputProps} />
        <div>
          <label htmlFor={renderedSelectId} style={{opacity: 0, position: 'absolute'}}>
            {selectLabel}
          </label>
          <TextInputField type="select" {...otherSelectProps} />
        </div>
      </div>
    </div>
  );
};
